// extracted by mini-css-extract-plugin
export var description = "headerIntro-module--description--4ef61";
export var title = "headerIntro-module--title--8affd";
export var wrapper = "headerIntro-module--wrapper--a5567";